import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { TableProps } from "../../../../Common/UI/Index";
import { PopulateTable } from "./Data";
import { FinalOutputListView } from "./FinalOutputList.view";

export const FinalOutputList: React.FC = () => {
  const dispatch = useDispatch();
  const [finalList, setFinalList] = useState<TableProps>({ headerRow: [], dataRow: [] });
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const { outputElements } = outputConfig;

  /**
   * To set final list when finalOutputList value changes
   */
  useEffect(() => {
    if (outputElements.length > 0) {
      setFinalList(PopulateTable(JSON.stringify(outputElements), dispatch));
    }
  }, [outputElements]);
  return (
    <FinalOutputListView list={finalList} />
  );
};
